import {mapGetters} from 'vuex'

export default{
  computed:{
    ...mapGetters('app/org', ['getPostById','getContainerById']),
  },
  
  data(){
    return {
      uuidRegexpPattern: /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/
    }
  },
  methods:{
    /**
     * Array structure:
     * {
     *    name: "",
     *    objects: [
     *      {
     *        element_type: "",
     *        identified: ""
     *      }
     *    ]
     * }
     * В поле name подставляются названия сущностей по id. Нужен на тот случай, когда название составное. Из нескольких объектов, разделенных символом.
     * @param data
     * @param separator
     * Исправлено!
     */
    convertUuidsToNames(data, separator = ' -> '){
      let posts = []
      let containers = []
      data.map(line => {
        let name = ''
        line.properties.map( (el, index)=>{
          let temp_name = el.identified
          if(el.element_type==='post'){
            let post = this.getPostById(el.identified)
            if(post.loaded){
              temp_name = post.name
            } else{
              temp_name = '*post*'+temp_name
              if(!posts.includes(el.identified)){
                posts.push(el.identified)
              }
            }
          } else if(el.element_type==='container'){
            let container = this.getContainerById(el.identified)
            if(container.loaded){
              temp_name = container.name
            } else{
              temp_name = '*cont*'+temp_name
              if(!containers.includes(el.identified)){
                containers.push(el.identified)
              }
            }
          }
          let sep = (index===line.properties.length-1) ? '' : separator
          name = name+temp_name+sep
        })
        this.$set(line, 'propsname', name)
      })
  
      if(posts.length>0 || containers.length>0){
        this.$store.dispatch('app/org/entitiesInfo', { posts, containers }).then( response => {
          //Парсинг имен объектов и замена uuid на соответствующее название поста
          data.map( line => {
            let names = line.propsname.split(separator)
            for(let i=0;i<names.length;i++){
              if(names[i].indexOf('*post*')===0){
                names[i] = names[i].substr(6)
                let post = this.getPostById(names[i])
                if(this.uuidRegexpPattern.test(names[i]) && post.loaded){
                  names[i] = post.name
                } else {
                  names[i] = 'Неизвестный объект'
                }
              } else if(names[i].indexOf('*cont*')===0){
                names[i] = names[i].substr(6)
                let container = this.getContainerById(names[i])
                if(this.uuidRegexpPattern.test(names[i]) && container.loaded){
                  names[i] = container.name
                } else {
                  names[i] = 'Неизвестный объект'
                }
              }
            }
            line.propsname = names.join(separator)
          })
        })
      }
    },
  
    /**
     * Метод для подстановки имен только в новой таблице ввода.
     * Исправлено!
     */
    convertTableLines(lines, result, separator = '\n'){
      let posts = []
      let containers = []
      
      lines.forEach( line => {
        let obj_array = []
        let name = ''
        line.properties.map( (el, index) => {
          let temp_name = el.identified
          if(el.element_type==='post'){
            let post = this.getPostById(el.identified)
            if(post.loaded){
              temp_name = post.name
            } else {
              temp_name = '*post*'+temp_name
              if(!posts.includes(el.identified)){
                posts.push(el.identified)
              }
            }
          } else if(el.element_type==='container'){
            let container = this.getContainerById(el.identified)
            if(container.loaded){
              temp_name = container.name
            } else{
              temp_name = '*cont*'+temp_name
              if(!containers.includes(el.identified)){
                containers.push(el.identified)
              }
            }
          }
          let sep = (index===line.length-1) ? '' : separator
          name = name+temp_name+sep
          obj_array.push(el.property_id)
        })
        result.push({
          id: line.id,
          temp_text: name.replace(/^\s+|\s+$/g, ''),
          text: `${line.name}${separator}(${name.replace(/^\s+|\s+$/g, '')})`,
          value: obj_array,
          sortable: false,
          align: 'center',
          class: 'data-table-header',
        })
      })
      
      //Запрос к оргструктуре на получение имен постов и вставка их в соответствующие места в заголовках таблицы
      if(posts.length>0 || containers.length>0){
        this.$store.dispatch('app/org/entitiesInfo', { posts, containers }).then( response => {
          //Парсинг имен объектов и замена uuid на соответствующее название поста
          result.map( obj => {
            let names = obj.temp_text.split(separator)
            for(let i=0;i<names.length;i++){
              if(names[i].indexOf('*post*')===0){
                names[i] = names[i].substr(6)
                let post = this.getPostById(names[i])
                if(this.uuidRegexpPattern.test(names[i]) && post.loaded){
                  names[i] = post.name
                } else {
                  names[i] = 'Неизвестный объект'
                }
              } else if(names[i].indexOf('*cont*')===0){
                names[i] = names[i].substr(6)
                let container = this.getContainerById(names[i])
                if(this.uuidRegexpPattern.test(names[i]) && container.loaded){
                  names[i] = container.name
                } else {
                  names[i] = 'Неизвестный объект'
                }
              }
            }
            obj.text = names.join(separator)
          })
        })
      }
    },
  
    /**
     *  Исправлено!
     */
    convertOutputSettings(setting){
      let posts = []
      let containers = []
    
      setting.map(set=>{
        let name = ''
        set.line.map( (item,index) => {
          let temp = ''
          if(item.type===1){
            temp = '<i aria-hidden="true" class="v-icon mdi mdi-sigma" style="font-size:19px"></i>('
          }
          item.properties.map( (obj, ind) => {
            obj.name = obj.identified
            if(obj.element_type==='post'){
              let post = this.getPostById(obj.identified)
              if(post.loaded){
                obj.name = post.name
              } else if(!posts.includes(obj.identified)){
                posts.push(obj.identified)
              }
            } else if(obj.element_type==='container'){
              let container = this.getContainerById(obj.identified)
              if(container.loaded){
                obj.name = container.name
              } else if(!containers.includes(obj.identified)){
                containers.push(obj.identified)
              }
            }
            let sep = (ind===item.properties.length-1) ? '' : '->'
            temp= temp + obj.name + sep
          })
          if(item.type===1) temp+=')'
          if(index!==set.line.length-1){
            temp+='<i aria-hidden="true" class="v-icon mdi mdi-ampersand" style="font-size:17px"></i>'
          }
          name+=temp
        })
        if(set.name===''){
          set.name=name
        } else {
          set.name+= ` (${name})`
        }
        
      })
    
      if(posts.length>0 || containers.length>0){
        this.$store.dispatch('app/org/entitiesInfo', { posts, containers }).then( response => {
          //Парсинг имен объектов и замена uuid на соответствующее название поста
          setting.map(set=>{
            let name = ''
            set.line.map( (item,index) => {
              let temp = ''
              if(item.type===1){
                temp = '<i aria-hidden="true" class="v-icon mdi mdi-sigma" style="font-size:19px"></i>('
              }
              item.properties.map( (obj, ind) => {
                if(obj.element_type==='post'){
                  let post = this.getPostById(obj.identified)
                  if(post.loaded){
                    obj.name = post.name
                  } else {
                    obj.name = 'Неизвестный объект'
                  }
                } else if(obj.element_type==='container'){
                  let container = this.getContainerById(obj.identified)
                  if(container.loaded){
                    obj.name = container.name
                  } else {
                    obj.name = 'Неизвестный объект'
                  }
                }
                let sep = (ind===item.properties.length-1) ? '' : '->'
                temp= temp + obj.name + sep
              })
              if(item.type===1) temp+=')'
              if(index!==set.line.length-1){
                temp+='<i aria-hidden="true" class="v-icon mdi mdi-ampersand" style="font-size:17px"></i>'
              }
              name+=temp
            })
            set.name = name
          })
        })
      }
    },
    
    
    /**
     * Метод для подстановки имен только в таблице ввода. ВОзможно не понадобится после переноса статистик
     */
    convertTableObjects(active, no_active, objects, deleted_objects, separator = '\n'){
      let posts = []
      let containers = []
  
      active.forEach( item => {
        let obj_array = []
        let name = ''
        item.map( (el, index) => {
          let temp_name = el.identified
          if(el.element_type==='post'){
            let post = this.getPostById(el.identified)
            if(post.loaded){
              temp_name = post.name
            } else {
              temp_name = '*post*'+temp_name
              if(!posts.includes(el.identified)){
                posts.push(el.identified)
              }
            }
          } else if(el.element_type==='container'){
            let container = this.getContainerById(el.identified)
            if(container.loaded){
              temp_name = container.name
            } else{
              temp_name = '*cont*'+temp_name
              if(!containers.includes(el.identified)){
                containers.push(el.identified)
              }
            }
          }
          let sep = (index===item.length-1) ? '' : separator
          name = name+temp_name+sep
          obj_array.push(el.object_id)
        })
        objects.push({
          text: name,
          value: obj_array,
          sortable: false,
          align: 'center',
          class: 'data-table-header',
        })
      })
  
      no_active.forEach( item => {
        let obj_array = []
        let name = ''
        item.map( (el, index) => {
          let temp_name = el.identified
          if(el.element_type==='post'){
            let post = this.getPostById(el.identified)
            if(post.loaded){
              temp_name = post.name
            } else {
              temp_name = '*post*'+temp_name
              if(!posts.includes(el.identified)){
                posts.push(el.identified)
              }
            }
          } else if(el.element_type==='container'){
            let container = this.getContainerById(el.identified)
            if(container.loaded){
              temp_name = container.name
            } else{
              temp_name = '*cont*'+temp_name
              if(!containers.includes(el.identified)){
                containers.push(el.identified)
              }
            }
          }
          let sep = (index===item.length-1) ? '' : separator
          name = name+temp_name+sep
          obj_array.push(el.object_id)
        })
        deleted_objects.push({
          text: name,
          value: obj_array,
          sortable: false,
          align: 'center',
          class: 'data-table-header',
        })
      })
  
      //Запрос к оргструктуре на получение имен постов и вставка их в соответствующие места в заголовках таблицы
      if(posts.length>0 || containers.length>0){
        this.$store.dispatch('app/org/entitiesInfo', { posts, containers }).then( response => {
          //Парсинг имен объектов и замена uuid на соответствующее название поста
          objects.map( obj => {
            let names = obj.text.split(separator)
            for(let i=0;i<names.length;i++){
              if(names[i].indexOf('*post*')===0){
                names[i] = names[i].substr(6)
                let post = this.getPostById(names[i])
                if(this.uuidRegexpPattern.test(names[i]) && post.loaded){
                  names[i] = post.name
                } else {
                  names[i] = 'Неизвестный объект'
                }
              } else if(names[i].indexOf('*cont*')===0){
                names[i] = names[i].substr(6)
                let container = this.getContainerById(names[i])
                if(this.uuidRegexpPattern.test(names[i]) && container.loaded){
                  names[i] = container.name
                } else {
                  names[i] = 'Неизвестный объект'
                }
              }
            }
            obj.text = names.join(separator)
          })
      
          deleted_objects.map( obj => {
            let names = obj.text.split(separator)
            for(let i=0;i<names.length;i++){
              if(names[i].indexOf('*post*')===0){
                names[i] = names[i].substr(6)
                let post = this.getPostById(names[i])
                if(this.uuidRegexpPattern.test(names[i]) && post.loaded){
                  names[i] = post.name
                } else {
                  names[i] = 'Неизвестный объект'
                }
              } else if(names[i].indexOf('*cont*')===0){
                names[i] = names[i].substr(6)
                let container = this.getContainerById(names[i])
                if(this.uuidRegexpPattern.test(names[i]) && container.loaded){
                  names[i] = container.name
                } else {
                  names[i] = 'Неизвестный объект'
                }
              }
            }
            obj.text = names.join(separator)
          })
        })
      }
    },
    
    convertArrayobjects(arr, prop = 'identified', type = 'element_type'){
      let posts = []
      let containers = []
      arr.map( item => {
        this.$set(item, 'name', item[prop])
        if(item[type]==='post'){
          let post = this.getPostById(item[prop])
          if(post.loaded){
            item.name = post.name
          } else if(!posts.includes(item[prop])){
            posts.push(item[prop])
          }
        } else if(item[type]==='container'){
          let container = this.getContainerById(item[prop])
          if(container.loaded){
            item.name = container.name
          } else if(!containers.includes(item[prop])){
            containers.push(item[prop])
          }
        }
      })
  
      //Запрос к оргструктуре на получение имен постов и вставка их в соответствующие места в заголовках таблицы
      if(posts.length>0 || containers.length>0){
        this.$store.dispatch('app/org/entitiesInfo', { posts, containers}).then( response => {
          //Парсинг имен объектов и замена uuid на соответствующее название поста
          arr.map( item => {
            if(item[type]==='post'){
              let post = this.getPostById(item[prop])
              if(post.loaded){
                item.name = post.name
              } else {
                item.name = 'Неизвестный объект'
              }
            } else if(item[type]==='container'){
              let container = this.getContainerById(item[prop])
              if(container.loaded){
                item.name = container.name
              } else {
                item.name = 'Неизвестный объект'
              }
            }
          })
        })
      }
    },
  }
}


// WEBPACK FOOTER //
// ./src/mixins/entities/index.js